export default __webpack_public_path__ + "static/media/missing-tooth.d161a9a3.png";